






























































import Vue from 'vue';
import Component from 'vue-class-component';
declare var iFrameResize: any;

@Component({})
export default class Intro extends Vue {

  private customerId: string | null = null;
  private customerToken: string | null = null;
  private logo = require('../assets/logo.png');
  private iframeHeight = 0;
  private showScroller = true;

  public onScroll(): void {
    const iframeForm = document.getElementById('iframeForm');
    if (!iframeForm) {
      return;
    }
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const offset = 60;
    if (currentScrollPosition < 0) {
      return;
    }
    this.showScroller = currentScrollPosition + document.documentElement.clientHeight < iframeForm.offsetTop + offset;
  }

  public onScrollerClick(): void {
    const iframeForm = document.getElementById('iframeForm');
    if (!iframeForm) {
      return;
    }
    document.documentElement.scrollTop = iframeForm.offsetTop;
    this.showScroller = false;
  }

  public async mounted(): Promise<void> {
    const {
      customerId,
      token,
    } = (this.$root as any).getCredentials();

    this.customerId = customerId;
    this.customerToken = token;

    const tryInit = () => {
      if (typeof iFrameResize !== 'function' || !document.getElementById('iframeForm')) {
        setTimeout(tryInit, 100);
      } else {
        iFrameResize({ log: false, checkOrigin: false, heightCalculationMethod: 'bodyScroll' }, '#iframeForm');
      }
    };

    tryInit();

    window.addEventListener('scroll', this.onScroll);
  }
}
